import { getField, updateField } from 'vuex-map-fields';

const SET_INFORMATION_DIALOG = 'INFORMATION_DIALOG';
const SET_AGREEMENT_DIALOG = 'AGREEMENT_DIALOG';
const SET_WELCOME_DIALOG = 'WELCOME_DIALOG';

const state = {
    isInformationDialog: false,
    isAgreementDialog: false,
    isWelcomeDialog: false
};

const actions = {
    /**
     * Set Information Dialog
     * @param {function} commit
     */
    setInformationDialog({ commit }) {
        commit(SET_INFORMATION_DIALOG);
    },

    /**
     * Set Agreement Dialog
     * @param {function} commit
     */
    setAgreementDialog({ commit }) {
        commit(SET_AGREEMENT_DIALOG);
    },

    /**
     * Set Welcome Dialog
     * @param {function} commit
     */
    setWelcomeDialog({ commit }) {
        commit(SET_WELCOME_DIALOG);
    }
};

const mutations = {
    // Add the `updateField` mutation to the
    // `mutations` of your Vuex store instance.
    updateField,
    [SET_INFORMATION_DIALOG](state) {
        state.isInformationDialog = !state.isInformationDialog;
    },
    [SET_AGREEMENT_DIALOG](state) {
        state.isAgreementDialog = !state.isAgreementDialog;
    },
    [SET_WELCOME_DIALOG](state) {
        state.isWelcomeDialog = !state.isWelcomeDialog;
    }
};

const getters = {
    // Add the `getField` getter to the
    // `getters` of your Vuex store instance.
    getField,
    isInformationDialog: state => state.isInformationDialog,
    isAgreementDialog: state => state.isAgreementDialog,
    isWelcomeDialog: state => state.isWelcomeDialog
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
